export class NCReadersModel {
	static ALDOPERATOR_READER: NCReaderItem = {
		id: 'ALD2SP',
		label: 'Operatore ALD'
	};
	static DELIVERYSP_READER: NCReaderItem = {
		id: 'SP2ALD',
		label: 'Operatore centro consegna'
	};
	static CCDEKRA_READER: NCReaderItem = {
		id: 'CCDEKRA',
		label: 'Centrale dekra'
	};
	static CCBACKOFFICE_READER: NCReaderItem = {
		id: 'CCBACKOFFICE',
		label: 'Backoffice dekra'
	};
	static CCSP_READER: NCReaderItem = {
		id: 'CCSP',
		label: 'Operatore centro riconsegna'
	};
	static CCDKO_READER: NCReaderItem = {
		id: 'CCDKO',
		label: 'Perito'
	};
	static SERVICE_POINT: NCReaderItem = {
		id: 'SERVICE_POINT',
	};
	static DEALER: NCReaderItem = {
		id: 'DEALER',
	};
	static ALD_OPERATOR: NCReaderItem = {
		id: 'ALD_OPERATOR',
	};
	static ALD_SUPERVISOR: NCReaderItem = {
		id: 'ALD_SUPERVISOR',
	};
	static POOL_OPERATOR: NCReaderItem = {
		id: 'POOL_OPERATOR'
	};
	static CUSTOMER_SERVICE_OPERATOR: NCReaderItem = {
		id: 'CUSTOMER_SERVICE_OPERATOR'
	};
}

export interface NCReaderItem {
	id: string;
	commodity_id?: string;
	label?: string;
}

export interface AlertReaderWithCommodity extends NCReaderItem {
	commodity_id?: string;
}
